<div class="modal-header">
  <button
    type="button"
    class="close d-none d-md-block"
    [ngClass]="{ 'btn btn-secondary btn-inverse': legal?.background?.trim() === 'black' }"
    data-dismiss="modal"
    aria-label="Close"
    (click)="activeModal.dismiss('close')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <button
    type="button"
    class="close d-md-none o-link-arrow o-link-small back"
    [ngClass]="{ 'o-link-reverse': legal?.background?.trim() === 'black' }"
    data-dismiss="modal"
    (click)="this.activeModal.dismiss('close')"
  >
    {{ 'dashboard.shared.common.close' | translate }}
  </button>
</div>
<div class="modal-body">
  <h4>{{ legal.label }}</h4>
  @if (isArray(legal.title)) {
    @for (line of $any(legal.title); track line) {
      <p class="standard font-weight-bold" [innerHTML]="transformContent(line) | sanitizeHtml"></p>
    }
  } @else {
    <p class="standard font-weight-bold" [innerHTML]="transformContent($any(legal.title)) | sanitizeHtml"></p>
  }
  @if (isArray(legal.text)) {
    @for (line of $any(legal.text); track line) {
      <p class="standard" [innerHTML]="transformContent(line) | sanitizeHtml"></p>
    }
  } @else {
    <p class="standard" [innerHTML]="transformContent($any(legal.text)) | sanitizeHtml"></p>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    [ngClass]="{ 'btn-inverse': legal?.background?.trim() === 'black' }"
    data-dismiss="modal"
    (click)="this.activeModal.dismiss('close')"
  >
    {{ 'dashboard.shared.common.close' | translate }}
  </button>
</div>
